// extracted by mini-css-extract-plugin
export var form = "form-small-module--form--JrUcq";
export var input = "form-small-module--input--r1oH7";
export var button = "form-small-module--button--Em3bA";
export var fadein = "form-small-module--fadein--GBnXN";